import { Box, TableCell } from '@material-ui/core'
import React from 'react'

export function TableHeadCell(props: {
  width?: number
  text?: string
  icon?: JSX.Element | null
  classNames?: string
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
}) {
  const { width, classNames, align, text, icon } = props
  const styleWidth = { width: width + '%' }
  return (
    <TableCell style={styleWidth} align={align}>
      <Box className={'flexCenter ' + classNames}>
        {icon}
        <b>{text}</b>
      </Box>
    </TableCell>
  )
}
